export default "__VITE_ASSET__DGnnwHJS__"